<template>
  <div class="kuangBox">
    <!-- 我的资产卡片 -->
    <div class="assetBox">
      <p class="txt">{{ $t('我的资产') }}</p>
      <p class="balanceList">
        <span class="balanceBox" @click="router('/balanceList', { type: 0 })">
          <span class="top">{{ $t('股权余额') }}</span>
          <span class="num">{{ userDate.balance || 0 }}</span>
        </span>
        <span class="balanceBox" @click="router('/balanceList', { type: 1 })">
          <span class="top">{{ $t('权益币余额') }}</span>
          <span class="num">{{ userDate.equity || 0 }}</span>
        </span>
        <span class="balanceBox" @click="router('/balanceList', { type: 3 })">
          <span class="top">{{ $t('注册币余额') }}</span>
          <span class="num">{{ userDate.coin || 0 }}</span>
        </span>
        <span class="balanceBox" @click="router('/balanceList', { type: 2 })">
          <span class="top">{{ $t('铸造币余额') }}</span>
          <span class="num">{{ userDate.mint || 0 }}</span>
        </span>
        <span class="balanceBox" @click="router('/subList')">
          <span class="top">{{ $t('子账号') }}</span>
        </span>
        <span class="balanceBox" @click="router('/balanceList', { type: 4 })">
          <span class="top">{{ $t('子币余额') }}</span>
          <span class="num">{{ userDate.sub_coin || 0 }}</span>
        </span>
      </p>
    </div>

    <!-- 钱包地址输入框 -->
    <div class="inputBox">
      <div class="inputLabel">{{ $t('钱包地址') }}</div>
      <input 
        type="text" 
        v-model="walletAddress" 
        :placeholder="$t('请输入接收矿机的钱包地址')"
        class="addressInput"
      />
    </div>

    <!-- 申请矿机按钮 -->
    <div class="applyBtnBox">
      <div class="applyBtn" @click="applyMiner">
        {{ $t('申请矿机') }}
      </div>
    </div>
  </div>
</template>

<script>
// 矿机页面
export default {
  data() {
    return {
      userDate: {},
      walletAddress: '' // 用户输入的钱包地址
    }
  },
  created() {
    console.log('[矿机页面] 组件创建，开始初始化...');
    // 获取缓存的用户信息
    let memberInfo = this.local.get('memberInfo');
    if (memberInfo) {
      console.log('[矿机页面] 从缓存加载用户信息:', memberInfo);
      this.userDate = JSON.parse(memberInfo);
    } else {
      console.log('[矿机页面] 缓存中无用户信息');
    }
    // 获取最新用户信息
    this.getMemberInfo();
  },
  methods: {
    // 获取用户信息
    getMemberInfo() {
      console.log('[矿机页面] 开始请求用户信息...');
      this.$get({
        url: `/member/getMemberInfo`,
        success: (res) => {
          console.log('[矿机页面] 用户信息获取成功:', res.data);
          this.userDate = res.data;
          // 缓存用户信息
          this.local.set('memberInfo', JSON.stringify(res.data));
        },
        tip: (res) => {
          console.error('[矿机页面] 用户信息获取失败:', res);
        }
      });
    },
    // 申请矿机
    applyMiner() {
      console.log('[矿机页面] ========== 开始申请矿机流程 ==========');
      console.log('[矿机页面] 点击申请矿机按钮');
      console.log('[矿机页面] 当前用户完整数据:', JSON.stringify(this.userDate, null, 2));
      console.log('[矿机页面] 用户输入的钱包地址:', this.walletAddress);
      
      // 步骤1: 检查是否有用户ID
      if (!this.userDate.id) {
        console.error('[矿机页面] ❌ 验证失败: 用户ID不存在');
        console.error('[矿机页面] 用户需要先登录');
        this.$toast('请先登录');
        return;
      }
      console.log('[矿机页面] ✅ 步骤1通过: 用户ID存在 ->', this.userDate.id);

      // 步骤2: 检查是否输入了钱包地址
      if (!this.walletAddress || this.walletAddress.trim() === '') {
        console.error('[矿机页面] ❌ 验证失败: 钱包地址未输入');
        this.$toast('请输入钱包地址');
        return;
      }
      console.log('[矿机页面] ✅ 步骤2通过: 钱包地址已输入 ->', this.walletAddress);

      // 步骤3: 准备请求参数（只发送 members_id 和 address）
      const requestData = {
        members_id: this.userDate.id,
        address: this.walletAddress.trim()
      };
      console.log('[矿机页面] ✅ 步骤3: 请求参数准备完成:', JSON.stringify(requestData, null, 2));
      
      // 步骤4: 发送申请请求
      console.log('[矿机页面] 🚀 步骤4: 开始发送POST请求到 https://admin.ltnova.com/api/miner_apply/apply');
      console.log('[矿机页面] 请求完整信息:');
      console.log('[矿机页面]   - URL: https://admin.ltnova.com/api/miner_apply/apply');
      console.log('[矿机页面]   - Method: POST');
      console.log('[矿机页面]   - Data:', requestData);
      
      this.$post({
        url: `https://admin.ltnova.com/api/miner_apply/apply`,
        loading: true,
        data: requestData,
        success: (res) => {
          console.log('[矿机页面] ========== 申请成功 ==========');
          console.log('[矿机页面] ✅ 响应状态码:', res.code);
          console.log('[矿机页面] ✅ 响应消息:', res.message);
          console.log('[矿机页面] ✅ 完整响应数据:', JSON.stringify(res, null, 2));
          
          this.$toast({
            message: res.msg || '申请成功',
            duration: 2000,
            onClose: () => {
              console.log('[矿机页面] Toast关闭，申请流程结束');
              // 清空输入框
              this.walletAddress = '';
              // 刷新用户信息
              this.getMemberInfo();
            }
          });
        },
        tip: (res) => {
          console.log('[矿机页面] ========== 申请失败 ==========');
          console.error('[矿机页面] ❌ 错误状态码:', res.code);
          console.error('[矿机页面] ❌ 错误消息:', res.message);
          console.error('[矿机页面] ❌ 完整错误数据:', JSON.stringify(res, null, 2));
          
          this.$toast(res.msg || '申请失败，请重试');
        }
      });
    }
  }
}
</script>

<style lang="less" scoped>
.kuangBox {
  width: 100%;
  min-height: 100vh;
  background-color: #446D7A;
  padding: 15px 15px 70px;
  
  // 我的资产卡片样式（从 mine.vue 复制）
  .assetBox {
    margin-top: 20px;
    padding: 10px 15px 5px;
    border-radius: 8px;
    background-image: url("../../assets/img/mine2.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .txt {
      color: #8b7248;
      font-size: 12px;
      margin-bottom: 10px;
      font-weight: bold;
    }
    .balanceList {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-wrap: wrap;
      .balanceBox {
        min-width: 33%;
        color: #796139;
        display: flex;
        flex-direction: column;
        align-items: center;
        font-weight: bold;
        padding: 0 2px;
        gap: 5px 0;
        margin: 0 0 10px;
        .top {
          width: 100%;
          text-align: center;
          font-size: 14px;
        }
        .num {
          width: 100%;
          text-align: center;
          font-size: 14px;
        }
      }
    }
  }

  // 钱包地址输入框区域
  .inputBox {
    margin-top: 30px;
    padding: 0 15px;
    
    .inputLabel {
      font-size: 14px;
      color: #DBC397;
      margin-bottom: 10px;
      font-weight: bold;
    }
    
    .addressInput {
      width: 100%;
      padding: 12px 15px;
      border: 2px solid #DBC397;
      border-radius: 8px;
      background-color: rgba(255, 255, 255, 0.1);
      color: #fff;
      font-size: 14px;
      outline: none;
      transition: all 0.3s;
      box-sizing: border-box;
      
      &::placeholder {
        color: rgba(255, 255, 255, 0.5);
      }
      
      &:focus {
        border-color: #BA9A66;
        background-color: rgba(255, 255, 255, 0.15);
      }
    }
  }

  // 申请矿机按钮区域
  .applyBtnBox {
    margin-top: 20px;
    padding: 0 15px;
    .applyBtn {
      width: 100%;
      padding: 15px 0;
      background: linear-gradient(134deg, #DBC397 0%, #BA9A66 100%);
      border-radius: 8px;
      text-align: center;
      font-size: 16px;
      font-weight: bold;
      color: #543b1b;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      transition: all 0.3s;
      
      &:active {
        transform: scale(0.98);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
      }
    }
  }
}
</style>
